/**
 * Binds a Select to one filter key.
 *
 * Lives in `lib/` because two features' filter bars need it, and plan §3.1
 * forbids one feature importing another — the startup and pilot lists are
 * siblings, not a hierarchy.
 *
 * Named rather than written inline because a Radix Select cannot be driven to
 * invoke its handler in jsdom: it positions its viewport with
 * `document.elementFromPoint`, which jsdom does not implement. As a named
 * function the binding is testable for what it is.
 */
export function filterHandler(
  key: string,
  onFilterChange: (key: string, value: string) => void,
): (value: string) => void {
  return (value: string): void => {
    onFilterChange(key, value);
  };
}
